import React from 'react';

const Modal = ({ children, onClose }) => (
  <div className="fixed inset-0 bg-black/40 backdrop-blur-sm overflow-y-auto h-full w-full flex items-center justify-center z-50">
    <div className="relative bg-white rounded-2xl shadow-2xl p-8 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto border border-slate-200">
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-slate-400 hover:text-slate-700 text-2xl w-8 h-8 rounded-full hover:bg-slate-100 flex items-center justify-center transition-all duration-200"
        aria-label="Close modal"
      >
        ×
      </button>
      {children}
    </div>
  </div>
);

export default Modal;
